function formattedCoinValue(coinValue) {
  return coinValue > 999 ? '+999' : coinValue;
}
export { formattedCoinValue };
